export default __webpack_public_path__ + "resources/icons/n222-72ab.png";